module.exports = __webpack_public_path__ + "img/business.faed7d32.png";